<template>
  <div v-show="show" class="mx-0">
    <v-snackbar
      v-model="snackbar"
      :min-width="0"
      color="#f8f3d6"
      top
      timeout="2000"
      class="black--text"
    >
      <span class="black--text">{{ notimsg }}</span>
    </v-snackbar>
    <v-card
      flat
      :color="wc_color"
      class="rounded-lg pb-6"
      style="margin-left: auto; margin-right: auto"
      :width="widthCard"
    >
      <v-card-title v-if="image" class="justify-center px-4">
        <v-img
          v-if="image_size === '100%'"
          :src="image_url"
          width="100"
          height="auto"
        ></v-img>
        <img v-else :src="image_url" :width="TabletSize || mobile_mode ? '100%' : image_size+'%'" />
        <!-- <img v-else :src="image_url" width="100%" /> -->
      </v-card-title>
      <v-card
        flat
        color="transparent"
        width="100%"
        class="d-flex justify-center align-center my-3"
      >
        <v-card flat :color="wc_bg_title" width="100%" class="mx-4">
          <v-card-title
            :style="`color: ${wc_title}; font-size: 20px;word-break: break-word;`"
            :class="`justify-${wc_justify}`"
          >
            {{ surveyInfo.surveyName }}</v-card-title
          >
          <v-card-subtitle
            :style="`color: ${wc_subtitle};text-align: ${wc_justify};word-break: break-word;`"
            >{{ surveyInfo.surveyDetail }}
          </v-card-subtitle>
        </v-card>
      </v-card>
      <v-card-title class="pa-0">
        <v-form ref="form" class="px-4" style="width: 100%">
          <v-container v-show="false">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  v-model="username"
                  label="ชื่อผู้ทำแบบสอบถาม"
                  :rules="[$store.getters.TextRule(username)]"
                  @keyup.enter="StartForm()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
          <v-text-field
            :outlined="default_theme.field_type === 'outlined'"
            :solo="default_theme.field_type === 'solo'"
            v-model="username"
            :dense="default_theme.field_dense"
            :label="default_theme.field_label"
            :color="default_theme.field_color"
            :background-color="default_theme.field_bg"
            :filled="default_theme.field_type === 'filled'"
            :rules="[$store.getters.TextRule(username)]"
            @keyup.enter="StartForm()"
          ></v-text-field>
          <v-card
            flat
            color="transparent"
            width="100%"
            class="d-flex justify-center my-3"
          >
            <v-btn
              :color="default_theme.button.bg_color"
              :style="`color: ${default_theme.button.text_color}`"
              :text="default_theme.button.bt_texttype === 'text'"
              :outlined="default_theme.button.bt_texttype === 'outlined'"
              :block="default_theme.button.bt_block"
              :rounded="default_theme.button.bt_rounded"
              @click="StartForm()"
              style="font-size: 16px"
              >{{ default_theme.button.text }}</v-btn
            >
          </v-card>
        </v-form>
      </v-card-title>
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
export default {
  props: [
    "config",
    "surveyInfo",
    "image",
    "image_url",
    "image_size",
    "wc_color",
    "wc_bg_title",
    "wc_title",
    "wc_subtitle",
    "wc_justify",
    "wc_fullwidth",
    "default_theme",
    "mobile_mode",
  ],
  data() {
    return {
      username: "",
      show: false,
      snackbar: false,
      notimsg: "",
    };
  },
  computed: {
    TabletSize() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown;
    },
    // widthCard() {
    //   if (this.TabletSize || this.mobile_mode) {
    //     return "100%";
    //   } else {
    //     if (this.image) {
    //       if (this.image_size === "100%") {
    //         return "100%";
    //       } else {
    //         return this.image_size + "%";
    //       }
    //     } else {
    //       return "100%";
    //     }
    //   }
    // },
    widthCard() {
      if (this.TabletSize || this.mobile_mode) {
        return "100%";
      } else {
        return "100%";
      }
    },
  },
  created() {
    // if (this.default_theme.autoform && !this.config) {
    //   this.username = "unknown_" + Date.now();
    //   this.$nextTick(() => {
    //     this.StartForm();
    //   });
    // }
    if (Object.keys(this.$route.query).includes("shared_token")) {
      if (this.$route.query.surveyID && this.$route.query.shared_token) {
        try {
          let jwtdata = jwtDecode(this.$route.query.shared_token);
          if (jwtdata.access_token) {
            try {
              let jwtdataonechat = jwtDecode(jwtdata.access_token);
              this.username = jwtdataonechat.username;
              this.$nextTick(() => {
                this.StartForm(jwtdataonechat);
              });
            } catch (error) {
              this.show = true;
              this.notimsg = "shared_token ไม่ถูกต้อง";
              this.snackbar = true;
            }
          } else {
            this.username = jwtdata.username;
            this.$nextTick(() => {
              this.StartForm(jwtdata);
            });
          }
        } catch (error) {
          this.show = true;
          this.notimsg = "shared_token ไม่ถูกต้อง";
          this.snackbar = true;
        }
      } else {
        let textalert = "กรุณาส่งข้อมูลให้ครบถ้วน";
        if (!this.$route.query.surveyID) {
          textalert = textalert + " (ไม่พบ surveyID)";
          Swal.fire({
            html: textalert,
            text: "",
            icon: "error",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonText: "ตกลง",
          });
        } else if (!this.$route.query.shared_token) {
          textalert = textalert + " (ไม่พบ shared_token)";
          this.show = true;
          this.notimsg = textalert;
          this.snackbar = true;
        }
      }
    } else {
      this.show = true;
    }
  },
  methods: {
    StartForm(jwtdata) {
      if (this.$refs.form.validate() && !this.config) {
        let userID = this.$store.getters.UUID();
        if (jwtdata) {
          userID = jwtdata.sub;
        }
        let data = {
          surveySession: "",
          surveyID: this.$route.query.surveyID,
          questionID: "start",
          answer: "",
          socialType: "webform",
          socialID: this.$route.query.surveyID,
          userID: userID,
          username: this.username,
        };
        this.$store
          .dispatch("StartForm", data)
          .then((response) => {
            this.$store.commit("setFirstquestion", response.questionInfo);
            this.$cookies.set(
              process.env.VUE_APP_COOKIE + "_surveyInfo",
              response.surveyInfo
            );
            this.$cookies.set(
              process.env.VUE_APP_COOKIE +
                "_" +
                response.surveySession +
                "_questionStep",
              {
                qlist: [response.questionInfo.questionID],
              }
            );
            let param = {
              surveyID: this.$route.query.surveyID,
              surveySession: response.surveySession,
              username: this.username,
              userID: userID,
              questionID: response.questionInfo.questionID,
            };
            if (this.$route.query.shared_token) {
              param.shared_token = this.$route.query.shared_token;
            }
            if (this.$route.query.socialType) {
              param.socialType = this.$route.query.socialType;
            }
            if (this.$route.query.token) {
              param.token = this.$route.query.token;
            }
            if (this.$route.query.socialID) {
              param.socialID = this.$route.query.socialID;
            }
            this.$router.push({
              path: "webform",
              query: param,
            });
          })
          .catch((err) => {
            // console.log(err);
            if (err.data.message === "surveyInfo not in Schedule Time") {
              Swal.fire({
                icon: "warning",
                text: "แบบสอบถามนี้ถูกเปลี่ยนให้สามารถทำได้ตามช่วงเวลาที่กำหนดเท่านั้น",
                title: "",
              }).then(() => {
                location.reload();
              });
            } else if (err.data.message === "surveyInfo status inactive") {
              Swal.fire({
                icon: "warning",
                text: "แบบสอบถามนี้ปิดรับคำตอบแล้ว",
                title: "",
              }).then(() => {
                location.reload();
              });
            } else if (
              err.data.message === "Dont have package or Package Expried"
            ) {
              Swal.fire({
                html: `แบบสอบถามนี้ไม่สามารถใช้งานได้ (Dont have package or Package Expried)<br>กรุณาติดต่อเจ้าของแบบสอบถาม`,
                icon: "warning",
                showCancelButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                confirmButtonColor: "#0093cc",
                confirmButtonText: "รับทราบ",
              });
            } else {
              let text = "ไม่สามารถเริ่มทำแบบสอบถามได้";
              Swal.fire({
                icon: "error",
                text: text,
                title: "",
              });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
